import { Skeleton } from '@vizit/atoms';
import { Asset } from '@vizit/molecules';
import { cx } from '@vizit/theme';
import * as React from 'react';
import { assetWrapperClasses, containerClasses, gridClasses, loadingDropTargetClasses } from './styles';

const LoadingCarouselGrid = React.memo(({ loadingCount, className }: { loadingCount: number; className?: string }) => {
  return (
    <div className={cx(containerClasses(), className)}>
      <Skeleton variant="square" className={loadingDropTargetClasses()} />
      <div className={gridClasses()}>
        {Array.from({ length: loadingCount }, (_, i) => `skeleton-${i}`).map((id) => (
          <div key={id} className={assetWrapperClasses()}>
            <Asset isLoading={true}>
              <Asset.Image name={`Product Image ${id}`} src={null} />
            </Asset>
          </div>
        ))}
      </div>
    </div>
  );
});

export { LoadingCarouselGrid };
